export const withElements = (props) => {
  const modifiers = Object.keys(props).filter((propName) =>
    propName.startsWith('_')
  )
  return [props.className, ...modifiers].join(' ')
}
